<template>
    <icon-base v-bind="$props">
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l3 3" />
    </icon-base>
</template>

<script setup>
import IconBase, { iconProps } from './IconBase.vue'

defineProps(iconProps)
</script>
